/**
 * Panda theme – kolory z Figma (WLC-Panda)
 * Primary: czerwony #db002f
 * Neutral: #1c1c1c (tekst), #555 (secondary), #f7f7f7 (tło)
 */
export default {
  palette: {
    common: {
      black: '#000',
      white: '#fff',
      dustyGray: '#979797',
      dustyGrayTransparent: '#9797973b',
      slateGray: '#788995',
      alto: '#d8d8d8',
      gallery: '#f0f0f0',
      hurricane: '#847e7d',
      mystic: '#dee3ec',
      mercury: '#e9e9e9',
      gray: '#838383',
      catskillWhite: '#f7f7f7',
      doveGray: '#555555',
      mineShaft: '#1c1c1c',
      whisper: '#f5f6fa',
      osloGray: '#868789',
      titanWhite: '#fefeff',
      flamingo: '#ef643b',
      lineIcon: '#CCD2E3',
      gray500: '#6B7280',
      gray400: '#bdbdbd',
      gray200: '#e3e3e3',
      gray300: '#d1d5db',
      gray50: '#f9fafb',
      neutral700: '#555555',
      neutral800: '#393939',
      neutral500: '#8E8E8E',
      neutral300: '#C6C6C6',
      red700: '#9D1424',
      red500: '#f05252',
      red300: '#f3807b',
      red100: '#FDDCD3',
      red50: '#fdf2f2'
    },
    background: {
      paper: '#fff',
      default: '#f7f7f7'
    },
    primary: {
      main: '#db002f',
      light: '#e95962',
      dark: '#c6002b',
      contrastText: '#fff',
      transparent: '#db002f26'
    },
    secondary: {
      main: '#000000',
      light: '#c6c6c6',
      dark: '#393939',
      contrastText: '#fff'
    },
    tertiary: {
      main: '#FFFFFF',
      light: '#C6C6C6',
      dark: '#E3E3E3',
      contrastText: '#1C1C1C'
    },
    error: {
      light: '#e02b36',
      main: '#db002f',
      dark: '#c6002b',
      contrastText: '#fff'
    },
    warning: {
      light: '#FFE882',
      main: '#ffdd59',
      dark: '#DBB841',
      contrastText: '#282166'
    },
    info: {
      light: '#36DBD2',
      main: '#00bec4',
      dark: '#0095A8',
      contrastText: '#fff'
    },
    success: {
      light: '#A8EF8E',
      main: '#82E569',
      dark: '#5CC44C',
      contrastText: '#282166'
    },
    text: {
      main: '#1c1c1c',
      secondary: '#555555'
    }
  },
  shape: {
    borderRadius: '4px'
  },
  shadows: {
    main: '0 4px 32px -1px rgba(12, 12, 13, 0.08)',
    paper: '0 4px 24px 0 rgba(12, 12, 13, 0.08)'
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
    dropdown: 1700
  },
  typography: {
    fontFamily: '\'Montserrat\', \'Open Sans\', sans-serif'
  },
  dimensions: {
    navHeight: '72px',
    bottomNavHeight: '54px',
    footerHeight: '54px',
    footerHeightMobile: '46px',
    navigationFullDrawerWidth: '240px',
    navigationShrinkDrawerWidth: '59px',
    authFormWidth: '600px',
    authRightSideBarWidth: '350px',
    inputHeight: '48px',
    buttonSmallHeight: '32px',
    buttonNormalHeight: '40px',
    buttonLargeHeight: '60px'
  },
  breakpoints: {
    mobile: 768,
    smallDesktop: 1024
  },
  breakpointsMedia: {
    mobile: '@media (max-width: 768px)',
    smallDesktop: '@media (min-width: 768px) and (max-width: 1024px)',
    tablet: '@media (max-width: 1024px)',
    desktop: '@media (min-width: 1025px)',
  }
}
